import { Button, Grid } from '@material-ui/core';
import React, { useState } from 'react';
import useStyles from '../../styles/useStyles';
import AddFolderDialog from './AddFolderDialog';
import ConfigurationFoldersGrid from './ConfigurationFoldersGrid';
import useSecurity from './../../hooks/useSecurity/useSecurity';
import { State } from '@progress/kendo-data-query';
import getDefaultGridState from '../../../core/types/common/DefaultGridState';
const ConfigurationFolder: React.FC<any> = () => {
    const classes = useStyles();
    const [newFolderModalVisible, setNewFolderModalVisible] = useState(false);
    const [addFoldersInGrid, setaddFoldersInGrid] = useState();
    const [gridState, setGridState] = useState<State>(getDefaultGridState());
    const { canManage } = useSecurity();
    return (
        <>
            {canManage() &&
            <AddFolderDialog
                newFolderModalVisible={newFolderModalVisible}
                setNewFolderModalVisible={setNewFolderModalVisible}
                setaddFoldersInGrid={setaddFoldersInGrid}
            />}
            <Grid style={{ display: 'flex', flexDirection: 'column' }}>
                <Grid item xs={12} className={classes.syncLogsGrid}>
                {canManage() && <Button
                        className={classes.addNewFolderButton}
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={() => setNewFolderModalVisible(!newFolderModalVisible)}
                    >
                        Add new folder
                    </Button>
                    }
                    <ConfigurationFoldersGrid addFoldersInGrid={addFoldersInGrid} gridState={gridState}  setGridState={setGridState} />
                </Grid>
            </Grid>
        </>
    );
};

export default ConfigurationFolder;
